/**
 * @generated SignedSource<<8be7e8e4812ad6b37093bfc36afac87c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type DepartmentType = "AQUATICS" | "AXE_THROWING" | "BASKETBALL" | "BOATING" | "BOCCE_BALL" | "BUSINESS" | "CARD_ROOM" | "CLUB" | "CROQUET" | "DINING" | "FITNESS" | "GOLF" | "HOCKEY" | "RACQUET" | "SALON" | "SHUFFLEBOARD" | "SPA";
export type LessonAccess = "BOOKING" | "NONE" | "REQUEST";
import { FragmentRefs } from "relay-runtime";
export type LessonFacilitySwitcherModalFragment_session$data = {
  readonly currentClientProfile: {
    readonly member: {
      readonly club: {
        readonly copyOverrides: {
          readonly lesson: {
            readonly singular: string;
          } | null | undefined;
        } | null | undefined;
        readonly facilities: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly department: {
                readonly type: DepartmentType;
              } | null | undefined;
              readonly isLessonsEnabled: boolean;
              readonly name: string;
              readonly privateLessonsPermissionSet: {
                readonly patronAccess: LessonAccess | null | undefined;
              } | null | undefined;
              readonly publicLessonsPermissionSet: {
                readonly patronAccess: LessonAccess | null | undefined;
              } | null | undefined;
              readonly slug: string;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      };
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"useIsCurrentUserPublic_session">;
  readonly " $fragmentType": "LessonFacilitySwitcherModalFragment_session";
};
export type LessonFacilitySwitcherModalFragment_session$key = {
  readonly " $data"?: LessonFacilitySwitcherModalFragment_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"LessonFacilitySwitcherModalFragment_session">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "patronAccess",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LessonFacilitySwitcherModalFragment_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useIsCurrentUserPublic_session"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Club",
              "kind": "LinkedField",
              "name": "club",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ClubCopyOverrides",
                  "kind": "LinkedField",
                  "name": "copyOverrides",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NounOverride",
                      "kind": "LinkedField",
                      "name": "lesson",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "singular",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FacilityConnection",
                  "kind": "LinkedField",
                  "name": "facilities",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "FacilityEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Facility",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "name",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "slug",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "isLessonsEnabled",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "PrivateLessonsPermissionSet",
                              "kind": "LinkedField",
                              "name": "privateLessonsPermissionSet",
                              "plural": false,
                              "selections": (v0/*: any*/),
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "PublicLessonsPermissionSet",
                              "kind": "LinkedField",
                              "name": "publicLessonsPermissionSet",
                              "plural": false,
                              "selections": (v0/*: any*/),
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Department",
                              "kind": "LinkedField",
                              "name": "department",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "type",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};
})();

(node as any).hash = "cf20ae732b6c00bdb245a76295a8a9b8";

export default node;
